export const MessageContainer = "MessageContainer";
export const MessageContainerMessage = `${MessageContainer}__Message`;